export const prototypeToString: (param: any) => string = param => {
  return Object.prototype.toString.call(param);
};

/**
 * 计算百分比对应的实际值
 * @param originNum 百分比计算基准值
 * @param percentage 百分比（仅支持 /^((0|[1-9][\d]*)(\.[\d]+)?)%$/形式）
 * @returns number 计算结果
 */
export const getNumFromPercentage = (originNum: number, percentage: string) => {
  const percentageRegex = /^((0|[1-9][\d]*)(\.[\d]+)?)%$/;
  let numRes = percentageRegex.exec(String(percentage));
  if (numRes) {
    const _num = Number(numRes[1] ?? 0);
    return (originNum * _num) / 100;
  }
  return 0;
};
